<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-17 10:51:08
 * @LastEditTime: 2019-08-11 22:16:45
 * @LastEditors: Please set LastEditors
 -->
<template>
   <div class='container'>
         <div class="title">
            数据概况
         </div>
         <ul class='surveyInfo clearfix'>
            <li class='fl'>
               <div class="clearfix">
                  <!-- <div class="icon">icon</div> -->
                  <div class='fr'>
                     <p>下级经销商总数</p>
                     <span>{{dealer_count}}</span>
                  </div>
               </div>
            </li>
              <li class='fl'>
               <div class="clearfix">
                  <!-- <div class="icon">icon</div> -->
                  <div class='fr'>
                     <p>门店总数</p>
                     <span>{{shop_count}}</span>
                  </div>
               </div>
            </li>
              <li class='fl'>
               <div class="clearfix">
                  <!-- <div class="icon">icon</div> -->
                  <div class='fr'>
                     <p>商品出货总量</p>
                     <span>{{out_stock_count}}</span>
                  </div>
               </div>
              
            </li>
              <li class='fl'>
               <div class="clearfix">
                  <!-- <div class="icon">icon</div> -->
                  <div class='fr'>
                     <p>返利余额</p>
                     <span>{{rebate_balance}}</span>
                  </div>
               </div>
              
            </li>
         </ul>
         <div class="overview">
            <div class="head">
               <div class='fl'>
                  出货数量趋势图
                  <br/>
                  <!-- (2019-03-11至2019-3-18) -->
               </div>
               <span>
                  <span>

                  </span>
                  出货数量
               </span>
                <div class="countType">
                <el-button size="mini" @click="countFun('day')" :class="{'active':home_type=='day'}">日</el-button>
                <el-button size="mini" @click="countFun('week')" :class="{'active':home_type=='week'}">周</el-button>
                <el-button size="mini" @click="countFun('month')" :class="{'active':home_type=='month'}">月</el-button>
                  </div>
            </div>
               <div id="charts"   ref='myEchart'></div>


               
         </div>
   </div>
</template>
<script>
import { option } from "@/assets/js/option/surveyOption.js";
export default {
   name:'survey',
   data(){
      return{
       home_type:'day',
       dealer_count:0,
       rebate_balance:0,
       shop_count:0,
       out_stock_count:0
       
      }
   },
   mounted(){
      this.chartsConfigure()
      this.getData()
   },
   methods:{
      chartsConfigure() {
      let myChart = this.$echarts.init(this.$refs.myEchart); //这里是为了获得容器所在位置
      window.onresize = myChart.resize;
      myChart.setOption(option);
    },
   timestampToTime(timestamp) {
        var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
       var Y = date.getFullYear() + '-';
       var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
       var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' ';
       var h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
       var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
       var s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());
        return Y+M+D;
    },
   getData(){
         this.$get('logistics','/home', {
            lang:'',
            home_type:this.home_type
         }).then(res => {
            this.dealer_count = res.data.dealer_count;
            this.rebate_balance =res.data.rebate_balance;
            this.shop_count=res.data.shop_count
            this.out_stock_count = res.data.out_stock_count;
             option.xAxis.data=[]
              option.series[0].data=[]
            for (var i = 0; i < res.data.statistics_data.length; i++) {
                          option.xAxis.data.push(res.data.statistics_data[i].name);

               // option.xAxis.data.push( this.timestampToTime(res.data.statistics_data[i].start_time));
               option.series[0].data.push(res.data.statistics_data[i].stock_out_num);
            }
             let myChart = this.$echarts.init(this.$refs.myEchart);
             myChart.setOption(option);
         }).catch(error => {
            this.$message({
               type: 'error',
               message: error.message
            });
            console.log(error);
         });
   },
   countFun(type){
            console.log(option,option.xAxis);
            this.home_type = type;
            option.xAxis.data = [];
             option.series[0].data = [];
            this.getData();
         }
   }
}
</script>


<style lang="scss" scoped>
.container{
   .title{
      padding: 10px;
   }
   .surveyInfo{
      margin-top: 50px;
      li{
         background-color: rgb(102, 153, 255);
         width: 21%;
         margin: 0 2%;
         border-radius: 8px;
         color: #fff;
         position: relative;
         min-height: 150px;
         >div{
            border-bottom: 1px solid #fff;
            min-height: 100px;
            padding: 5px;
            text-align: right;
            line-height: 22px;
             .icon{
            position: absolute;
            background-color: #fff;
            width:88px;
            height:88px;
            border: 1px solid #eee;
            top: -44px;
            left: 44px;
         }
         }
      }
   li:nth-child(2){
      background-color: rgb(255, 51, 204);
   }
   li:nth-child(3){
      background-color: rgb(102, 102, 204);
   }
   li:nth-child(4){
      background-color: rgb(255, 102, 0);
   }
   }
   .overview{
      height: 550px;
      border: 1px solid #eee;
      border-radius: 8px;
      margin: 15px 0;
      .head{
         height: 100px;
         padding: 10px;
         text-align: center;
         font-size: 14px;
         color: #333;
         line-height: 20px;
         position: relative;
         span{
            display: inline-block;
            >span{
               background-color: rgb(0, 51, 255);
               width: 30px;
               height: 10px;
               border-radius: 8px;
            }
         }
         ul{
            li{
              padding: 2px 25px;
               border: 1px solid #eee;
               border-radius: 8px;
               margin-right: 5px;
            }
            .active{
                 background-color: rgb(0, 51, 255);
                 color: #fff;
            }
         }
      }
      #charts{
         height: 400px;
      }
   }
}
.countType{
            z-index: 99999;
            height: 40px;
            width: 200px;
            position: absolute;
            right:0;
            bottom:-60px;
        }
        .active{
           background-color:rgb(240, 249, 235);
           color: rgb(103, 194, 135)
        }
</style>
